import React from 'react';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';

import { useMytaverseEvent } from '@core/dashboard/providers';

const useShareWebcam = () => {
  const { ueWebcamScreenName, ueWebcamMediaStreams } = useConference();

  const { currentParticipant } = useMytaverseEvent();

  const currentParticipantId = currentParticipant?.participantId || '';

  const currentCameraSharing = React.useMemo(() => {
    return !!ueWebcamMediaStreams.find(
      (ms) =>
        ms.participantId === currentParticipantId &&
        ms.ueScreenName === ueWebcamScreenName &&
        ms.source === 'CAMERA',
    );
  }, [ueWebcamMediaStreams, ueWebcamScreenName, currentParticipantId]);

  return { currentCameraSharing };
};

export default useShareWebcam;
